import { render, staticRenderFns } from "./replyComp.vue?vue&type=template&id=639f4eae&scoped=true&"
import script from "./replyComp.vue?vue&type=script&lang=js&"
export * from "./replyComp.vue?vue&type=script&lang=js&"
import style0 from "./replyComp.vue?vue&type=style&index=0&id=639f4eae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f4eae",
  null
  
)

export default component.exports